import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";

let lenisInstance = null;
export const getLenis = () => lenisInstance;

// Momentum scrolling (skipped for reduced-motion users), scroll-to-top on route change, and #anchor scrolling.
export const SmoothScroll = () => {
  const { pathname, hash, key } = useLocation();
  const prevPath = useRef(pathname);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisInstance = lenis;
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  useEffect(() => {
    const changedPage = prevPath.current !== pathname;
    prevPath.current = pathname;
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (!el) return;
        if (lenisInstance) lenisInstance.scrollTo(el, { offset: -80 });
        else el.scrollIntoView({ behavior: "smooth" });
      }, changedPage ? 350 : 50);
      return () => clearTimeout(t);
    }
    if (changedPage) {
      window.scrollTo(0, 0);
      lenisInstance?.scrollTo(0, { immediate: true });
    }
    return undefined;
  }, [pathname, hash, key]);

  return null;
};
